import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { specials } from "@/mocks/specials";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 text-background-200">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500 text-primary-950">
                <i className="ri-film-fill text-xl" />
              </span>
              <span className="font-heading font-extrabold text-lg text-background-50">
                欧美大片
              </span>
            </div>
            <p className="text-sm leading-relaxed text-background-300/80">
              专注提供最新最全的欧美电影资讯、深度影评与精选推荐，陪伴每一位影迷找到下一部值得观看的好电影。
            </p>
            <div className="flex items-center gap-3 mt-5">
              {["ri-wechat-line", "ri-weibo-line", "ri-mail-line", "ri-rss-line"].map(
                (icon) => (
                  <span
                    key={icon}
                    className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-900 text-background-200 hover:bg-accent-500 hover:text-primary-950 transition-colors cursor-pointer"
                  >
                    <i className={icon} />
                  </span>
                ),
              )}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-50 mb-4 text-sm tracking-wide">
              电影分类
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.key}>
                  <Link
                    to={`/category/${cat.key}`}
                    className="text-sm text-background-300/80 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {cat.name}电影
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-50 mb-4 text-sm tracking-wide">
              影评专题
            </h4>
            <ul className="space-y-2.5">
              {specials.map((sp) => (
                <li key={sp.id}>
                  <Link
                    to={`/special/${sp.id}`}
                    className="text-sm text-background-300/80 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {sp.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-50 mb-4 text-sm tracking-wide">
              关于我们
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-300/80 hover:text-accent-400 transition-colors cursor-pointer"
                >
                  网站介绍
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-300/80 hover:text-accent-400 transition-colors cursor-pointer"
                >
                  内容范围说明
                </Link>
              </li>
              <li>
                <Link
                  to="/search"
                  className="text-sm text-background-300/80 hover:text-accent-400 transition-colors cursor-pointer"
                >
                  搜索电影
                </Link>
              </li>
              <li className="text-sm text-background-300/80 flex items-start gap-2">
                <i className="ri-mail-line mt-0.5" />
                contact@oumeidapian.example
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-300/60 text-center sm:text-left">
            © {new Date().getFullYear()} 欧美大片影视网 · 本站所有影视资讯、影评均为示范内容
          </p>
          <p className="text-xs text-background-300/60">
            数据仅供演示 · 未接入真实数据接口
          </p>
        </div>
      </div>
    </footer>
  );
}